export async function switchUserWorkMode({
                                             currentIsStaff,
                                             targetIsStaff,
                                             switchType,
                                         }) {
    if (typeof currentIsStaff !== "boolean") {
        throw new TypeError("currentIsStaff must be boolean");
    }

    if (typeof targetIsStaff !== "boolean") {
        throw new TypeError("targetIsStaff must be boolean");
    }

    if (currentIsStaff === targetIsStaff) {
        return false;
    }

    if (typeof switchType !== "function") {
        throw new TypeError("switchType must be function");
    }

    await switchType();

    return true;
}
